export const toggleFullscreen = async (el: HTMLElement | null) => {
  if (!el) return;
  try {
    if (!document.fullscreenElement) {
      await el.requestFullscreen();
    } else {
      await document.exitFullscreen();
    }
  } catch (e) {
    console.error('Fullscreen failed', e);
  }
};
